<template>
  <div v-if="loading" class="row" style="background-color: #fff;">
    <div class="col-12">
      <!-- <div class="loader">
        <b-spinner
          variant="primary"
          type="grow"
          :label="`${$t('reports.detractor.loadingLabel')}...`"
        ></b-spinner>
      </div> -->
      <b-table
        striped
        responsive
        id="table-positive"
        :items="[0, 1, 2, 3]"
        :fields="fieldsPositive"
        style="font-size: 12px;"
      >
        <template v-slot:cell(progress)>
          <div style="min-width: 70px;">
            <idx-skeleton width="180" height="15" radius="10" />
          </div>
        </template>
        <template v-slot:cell(word)>
          <div style="min-width: 70px;">
            <idx-skeleton width="80" height="15" radius="10" />
          </div>
        </template>
        <template v-slot:cell(percentage)>
          <idx-skeleton width="45" height="15" radius="10" />
        </template>
        <template v-slot:cell(occurrences)>
          <idx-skeleton width="45" height="15" radius="10" />
        </template>
      </b-table>
    </div>
  </div>
  <div v-else class="row">
    <div class="col-12 text-center">
      <div class="row" style="justify-content: center; margin-top: 20px;">
        <div
          style="
            background: #f0f6fb;
            border-radius: 20px;
            padding-left: 20px;
            padding-right: 20px;
            font-size: 12px;
          "
        >
          <b-button-group>
            <b-button
              class="buttons-filters"
              @click="key = 'positive'"
              v-bind:class="{
                active: key === 'positive',
              }"
              >Positivas</b-button
            >
            <b-button
              class="buttons-filters"
              @click="key = 'negative'"
              v-bind:class="{
                active: key === 'negative',
              }"
              >Negativas</b-button
            >
            <b-button
              class="buttons-filters"
              @click="key = 'neutral'"
              v-bind:class="{
                active: key === 'neutral',
              }"
              >Neutras</b-button
            >
          </b-button-group>
        </div>
      </div>

      <div class="reports-wrapper" style="margin-top: 16px;">
        <div class="" style="width: 100%;">
          <div class="row center-table">
            <div v-if="key === 'positive'" class="col-12">
              <b-table
                striped
                responsive
                id="table-positive"
                :items="data.positiveKeyWords"
                :fields="fieldsPositive"
                style="font-size: 12px;"
              >
                <template v-slot:table-busy>
                  <div class="text-center text-primary my-2">
                    <b-spinner type="grow" class="align-middle"></b-spinner>
                  </div>
                </template>
                <template v-slot:cell(progress)="row">
                  <div style="min-width: 70px;">
                    <b-progress
                      variant="primary"
                      :value="row.item.percentage"
                      :max="100"
                    ></b-progress>
                  </div>
                </template>
                <template v-slot:cell(percentage)="row">
                  {{ row.item.percentage + '%' }}
                </template>
              </b-table>
            </div>
            <div v-if="key === 'neutral'" class="col-12">
              <b-table
                striped
                responsive
                id="table-neutral"
                :items="data.neutralKeyWords"
                :fields="fieldsNeutral"
                style="font-size: 12px;"
              >
                <template v-slot:table-busy>
                  <div class="text-center text-primary my-2">
                    <b-spinner type="grow" class="align-middle"></b-spinner>
                  </div>
                </template>
                <template v-slot:cell(progress)="row">
                  <div style="min-width: 70px;">
                    <b-progress
                      variant="warning"
                      :value="row.item.percentage"
                      :max="100"
                    ></b-progress>
                  </div>
                </template>
                <template v-slot:cell(percentage)="row">
                  {{ row.item.percentage + '%' }}
                </template>
              </b-table>
            </div>
            <div v-if="key === 'negative'" class="col-12">
              <b-table
                striped
                responsive
                id="table-negative"
                :items="data.negativeKeyWords"
                :fields="fieldsNegative"
                style="font-size: 12px;"
              >
                <template v-slot:table-busy>
                  <div class="text-center text-primary my-2">
                    <b-spinner type="grow" class="align-middle"></b-spinner>
                  </div>
                </template>
                <template v-slot:cell(progress)="row">
                  <div style="min-width: 70px;">
                    <b-progress
                      variant="danger"
                      :value="row.item.percentage"
                      :max="100"
                    ></b-progress>
                  </div>
                </template>
                <template v-slot:cell(percentage)="row">
                  {{ row.item.percentage + '%' }}
                </template>
              </b-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import idxSkeleton from '@/components/molecules/idx-skeleton';
import RadialProgressBar from 'vue-radial-progress';
import Indicators from '../../reports/indicators';
import api from '../../../../../services/api';
import EventBus from '../../../../../eventBus';

export default {
  components: {
    RadialProgressBar,
    Indicators,
    idxSkeleton,
  },

  props: ['dataGraph'],

  data: () => ({
    loading: true,
    key: 'positive',
    data: {
      totalAnswers: 0,
      totalAnswersAnalyzed: 0,
      positiveQty: 0,
      neutralQty: 0,
      negativeQty: 0,
      score: 0,
      scoreColor: '#c1c1c1',
      positiveKeyWords: [],
      neutralKeyWords: [],
      negativeKeyWords: [],
    },
    fieldsPositive: [
      { key: 'word', label: 'Keywords positivas' },
      {
        key: 'progress',
        label: '',
      },
      {
        key: 'percentage',
        label: 'Score',
      },
      {
        key: 'occurrences',
        label: 'Total',
      },
    ],
    fieldsNeutral: [
      { key: 'word', label: 'Keywords neutras' },
      {
        key: 'progress',
        label: '',
      },
      {
        key: 'percentage',
        label: 'Score',
      },
      {
        key: 'occurrences',
        label: 'Total',
      },
    ],
    fieldsNegative: [
      { key: 'word', label: 'Keywords negativas' },
      {
        key: 'progress',
        label: '',
      },
      {
        key: 'percentage',
        label: 'Score',
      },
      {
        key: 'occurrences',
        label: 'Total',
      },
    ],
    currentPage: 1,
  }),

  methods: {
    async getReportsData(data) {
      this.loading = true;

      await this.getSentmentAnalysisInfo(data);

      this.loading = false;
    },

    async getSentmentAnalysisInfo(dataGraph) {
      const response = await api.get('/reports/sentment-analysis-panel', {
        headers: {
          'x-access-token': this.userAuth.token,
        },
        params: {
          actionId: dataGraph.actionId ? dataGraph.actionId._id : null,
          startDate: null,
          endDate: null,
          ih1: this.dataGraph.ih1 && this.dataGraph.ih1.length > 0 ? this.dataGraph.ih1.map((item) => item._id): null,
          metric: dataGraph.metric,
          groupId: dataGraph.actionGroupId ? dataGraph.actionGroupId._id : null,
          indicator: dataGraph.indicator ? dataGraph.indicator : null,
          indicatorValue: dataGraph.valueIndicator,
          // indicatorRange: this.indicatorData.range,
          period: dataGraph.period,
          _id: dataGraph._id,
        },
      });

      this.data.totalAnswers = response.data.totalAnswers;
      this.data.totalAnswersAnalyzed = response.data.totalAnswersAnalyzed;

      this.data.positiveQty = response.data.qty.positive;
      this.data.neutralQty = response.data.qty.neutral;
      this.data.negativeQty = response.data.qty.negative;
      this.data.score = response.data.score.total;
      this.data.scoreColor = this.setColor(response.data.score.total);

      this.data.positiveKeyWords = response.data.keyWords.positive;
      this.data.neutralKeyWords = response.data.keyWords.neutral;
      this.data.negativeKeyWords = response.data.keyWords.negative;
    },

    setColor(score) {
      if (score >= 60) {
        return '#22CD70';
      } else if (score >= 0) {
        return '#F3C102';
      }

      return '#E84C3E';
    },
  },

  async created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    await this.getReportsData(this.dataGraph);

    EventBus.$on('update-indicator-sentiment', (items) => {
      this.getReportsData(items);
    });
  },
};
</script>

<style scoped lang="scss">
.center-table {
  display: flex;
  padding: 0;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.buttons-filters {
  background: #f0f6fb;
  border-radius: 50rem;
  padding-left: 15px;
  padding-right: 15px;
  border: none;
  outline: none;
  font-size: 12px;
}

.buttons-filters.active {
  background: #fff !important;
  border-radius: 50rem !important;
  padding-left: 15px !important ;
  padding-right: 15px !important;
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
  font-weight: bold !important;
}

.loader {
  width: 100%;
  height: 350px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.reports-wrapper {
  width: 100%;
  display: flex;
  overflow: hidden;
  flex-direction: row;
  justify-content: space-between;
}

.card {
  background-color: #fff;
  padding: 16px;

  h1 {
    font-size: 22px;
  }

  .sentiment-area {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }
}

.page-spacing {
  padding-left: 15px;
  padding-right: 15px;
}

.graphic-card {
  display: flex;
  flex-direction: column;
  padding: 15px 35px;
  border: 1px solid #eee;
  height: 100%;
}

.chart-area {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.text-color {
  color: #5f6368;
  font-size: 18px;
  fill: #5f6368;
}

.highcharts-background-pie {
  width: 0;
}

.numbers-area {
  max-width: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/molecules/highcharts/sentment-analysis/panels/top-keywords.vue